import React from 'react';
import {
    Grid,
    Typography,
} from '@saddlebackchurch/react-cm-ui';
import searchImage from '../assets/search.svg';
import { getImageUrl } from '../js/imageUtilities';

function NoResultFound({ className }: { className?: string; }) {
    return (
        <Grid
            alignContent="center"
            alignItems="center"
            className={className}
            direction="column"
            justifyContent="center"
            spacing={2}
        >
            <Grid.Column>
                <img
                    alt="Search"
                    src={getImageUrl(searchImage)}
                />
            </Grid.Column>
            <Grid.Column>
                <Typography variant="h3">
                    No results found
                </Typography>
            </Grid.Column>
            <Grid.Column>
                <Typography variant="body1">
                    We couldn&rsquo;t find what you were looking for. Please try a different search.
                </Typography>
            </Grid.Column>
        </Grid>
    );
}

export default NoResultFound;
